import { render, staticRenderFns } from "./WonderUplimitPromotionDaily.vue?vue&type=template&id=fb1caf48&scoped=true"
import script from "./WonderUplimitPromotionDaily.vue?vue&type=script&lang=js"
export * from "./WonderUplimitPromotionDaily.vue?vue&type=script&lang=js"
import style0 from "./WonderUplimitPromotionDaily.vue?vue&type=style&index=0&id=fb1caf48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb1caf48",
  null
  
)

export default component.exports